import { extendTheme, theme, ThemeConfig } from '@chakra-ui/react'

import components from '@config/theme/components'
import global from '@config/theme/global'

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false
}

const overrides = {
  styles: {
    global: () => ({
      ...global
    })
  },
  theme: {
    ...theme,
    shadows: {
      ...theme.shadows,
      outline: 'none'
    }
  },
  components,
  config
}

export default extendTheme(overrides)
